module.exports = __webpack_public_path__ + "static/media/chat.adc34674.svg";